export default __webpack_public_path__ + "static/media/photo--lg--leena-3.f1ce3c51.jpg";